module.exports = __webpack_public_path__ + "img/link_chain_on_gray.63634268.svg";